module.exports = __webpack_public_path__ + "teqbahn-assets/media/10.c62195f0.jpg";